import React, { Suspense, lazy } from 'react'
import StylesWithMaterialUi from './App.styles'
import { BrowserRouter } from 'react-router-dom'
import CircularProgressComponent from '../../components/MatrialUiComponents/CircularProgress/CircularProgressComponent'

const HeaderComponent = lazy(() => import('../../layouts/Header/Header'))

const App = () => {
  const classes = StylesWithMaterialUi()

  return (
    <BrowserRouter>
      <Suspense
        fallback={<CircularProgressComponent className={classes.root} />}
      >
        <HeaderComponent />
      </Suspense>
    </BrowserRouter>
  )
}

export default App
